import React, { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import SidebarLogo from "../components/sidebar/sidebarlogo";
import SidebarMenu from "../components/sidebar/sidebarmenu";
import SidebarProfile from "../components/sidebar/sidebarprofile";

export default function Sidebar({ isMobileOpen, setIsMobileOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const [isMobile, setIsMobile] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const storedUser = user || JSON.parse(sessionStorage.getItem("user"));
  const userName = storedUser?.username;
  const userEmail = storedUser?.email;

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (e) {
      console.error("Logout failed", e);
    }
  };

  return (
    <>
      {isMobile && (
        <div
          className={`fixed inset-0 bg-black/40 z-40 transition-all duration-300 ${isMobileOpen ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-full bg-white border-r border-gray-100 flex flex-col z-50 transition-transform duration-300 ease-in-out ${isMobile
            ? `w-24 shadow-lg ${isMobileOpen ? "translate-x-0" : "-translate-x-full"}`
            : "w-24"
          }`}
      >
        <SidebarLogo />
        <SidebarMenu
          navigate={navigate}
          location={location}
          isMobile={isMobile}
          setIsMobileOpen={setIsMobileOpen}
        />
        <SidebarProfile
          profileOpen={profileOpen}
          setProfileOpen={setProfileOpen}
          userName={userName}
          userEmail={userEmail}
          handleLogout={handleLogout}
        />
      </aside>

      {isMobile && !isMobileOpen && (
        <button
          onClick={() => setIsMobileOpen(true)}
          className="fixed top-5 left-4 z-40 w-10 h-10 bg-white border border-gray-300 rounded-lg shadow flex items-center justify-center hover:bg-gray-50"
        >
          <Menu className="w-5 h-5 text-gray-600" />
        </button>
      )}
    </>
  );
}
